import {
  type Color,
  filterDeficiencyDeuter,
  filterDeficiencyProt,
  filterDeficiencyTrit,
  formatHex,
} from "culori";
import { fromLch, type Hex, toLch } from "./oklch";

export type VisionMode = "normal" | "protanopia" | "deuteranopia" | "tritanopia" | "achromatopsia";

export const VISION_MODES: { id: VisionMode; label: string; hint: string }[] = [
  { id: "normal", label: "Normal vision", hint: "No simulation" },
  { id: "protanopia", label: "Protanopia", hint: "No red cones (~1% of men)" },
  { id: "deuteranopia", label: "Deuteranopia", hint: "No green cones (~1% of men)" },
  { id: "tritanopia", label: "Tritanopia", hint: "No blue cones (rare)" },
  { id: "achromatopsia", label: "Achromatopsia", hint: "No color, lightness only" },
];

type Filter = (color: Color | string) => Color;

const filters: Record<"protanopia" | "deuteranopia" | "tritanopia", Filter> = {
  protanopia: filterDeficiencyProt(1) as Filter,
  deuteranopia: filterDeficiencyDeuter(1) as Filter,
  tritanopia: filterDeficiencyTrit(1) as Filter,
};

export function simulate(hex: Hex, mode: VisionMode): Hex {
  if (mode === "normal") return hex;
  if (mode === "achromatopsia") return fromLch({ ...toLch(hex), c: 0 });
  return (formatHex(filters[mode](hex)) ?? hex) as Hex;
}
